import React, { useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { GOLD_TEXT } from "constants/brandColors";

// Shared "are you sure?" dialog for destructive actions (delete news, delete
// image/video, etc.) — the only prior art in this codebase was a bare
// window.confirm() in the old Ucleany screens, which doesn't match the rest
// of this dashboard's themed modals/toasts.
function ConfirmDialog({ isOpen, title, body, confirmLabel, cancelLabel, isLoading, onConfirm, onClose }) {
  const { t } = useTranslation();
  const cancelRef = useRef(null);

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="700" color={GOLD_TEXT}>
            {title || t("Are you sure?")}
          </AlertDialogHeader>
          <AlertDialogBody>{body || t("This action cannot be undone.")}</AlertDialogBody>
          <AlertDialogFooter gap={3}>
            <Button ref={cancelRef} variant="outline" borderColor="gray.200" color="gray.700" onClick={onClose}>
              {cancelLabel || t("Cancel")}
            </Button>
            <Button colorScheme="red" onClick={onConfirm} isLoading={isLoading}>
              {confirmLabel || t("Delete")}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export default ConfirmDialog;
